import React, { useState } from "react";
import styled from "styled-components";
import { Logo } from "../../../assets/images/Logo";
import { COLORS } from "../../../assets/constants/styles";
import { Button } from "../../common/Button/Button";
import { useTranslation } from "react-i18next";
import { trackEvent } from "../../../helpers/analytics-helpers";
import { openExtensionStore } from "../../../helpers/various-helpers";
import { DemoModal } from "../../common/DemoModal/DemoModal";

export const MobileMenu = ({ isOpen, onClose, navItems, handleNavClick }) => {
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <MenuOverlay $isOpen={isOpen}>
        <TopSection>
          <MenuHeader>
            <TitleContainer onClick={(e) => handleNavClick(e, "#top")}>
              <LogoContainer>
                <Logo />
              </LogoContainer>
              <Title>Grensa.AI</Title>
            </TitleContainer>
            <CloseButton onClick={onClose}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M18 6L6 18M6 6L18 18"
                  stroke="currentColor"
                  strokeWidth="2"
                />
              </svg>
            </CloseButton>
          </MenuHeader>

          <MenuNav>
            {navItems.map((item) => (
              <MenuItem
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
              >
                {item.title}
              </MenuItem>
            ))}
          </MenuNav>
        </TopSection>
        <BottomSection>
          <Button
            text={t("buttons.try")}
            onClick={() => {
              // eslint-disable-next-line no-undef
              ym(100699774, "reachGoal", "TRY_NOW");
              trackEvent("try-now");
              openExtensionStore();
            }}
          />

          <Button
            text={t("buttons.demoCall")}
            variant="white"
            onClick={() => {
              // eslint-disable-next-line no-undef
              ym(100699774, "reachGoal", "DEMO_CALL");
              trackEvent("demo-call");
              setIsModalOpen(true);
              onClose();
            }}
          />
        </BottomSection>
      </MenuOverlay>
      <DemoModal
        isModalOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
      />
    </>
  );
};

const MenuOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${COLORS.white};
  z-index: 1000;
  display: ${(props) => (props.$isOpen ? "flex" : "none")};
  flex-direction: column;
  padding: 16px;
  justify-content: space-between;
  background-color: ${COLORS.lightViolet};
`;

const TopSection = styled.div``;

const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const MenuHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 27.32px;
  margin-left: 8px;
  color: ${COLORS.black};
`;

const LogoContainer = styled.div`
  width: 32px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
`;

const MenuNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const MenuItem = styled.a`
  color: ${COLORS.black};
  text-decoration: none;
  font-size: 16px;
  padding: 8px 0;
`;
